import customFetch from './customFetch';

const SESSION_KEY = 'svisit_session';
const SESSION_DURATION = 30 * 60 * 1000; // 30 minutes

// Get or create session ID
export const getSessionId = () => {
  const stored = localStorage.getItem(SESSION_KEY);

  if (stored) {
    try {
      const { sessionId, timestamp } = JSON.parse(stored);
      const now = Date.now();

      // Check if session is still valid
      if (now - timestamp < SESSION_DURATION) {
        // Update timestamp
        localStorage.setItem(
          SESSION_KEY,
          JSON.stringify({ sessionId, timestamp: now })
        );
        return sessionId;
      }
    } catch (error) {
      // If parsing fails, create new session
      console.error('Error parsing session:', error);
    }
  }

  // Create new session
  const newSessionId = crypto.randomUUID();
  localStorage.setItem(
    SESSION_KEY,
    JSON.stringify({ sessionId: newSessionId, timestamp: Date.now() })
  );

  return newSessionId;
};

// Track event
const trackEvent = async (eventType, data = {}) => {
  try {
    await customFetch.post('/public/analytics/track', {
      eventType,
      sessionId: getSessionId(),
      ...data,
    });
  } catch (error) {
    // Silently fail - don't disrupt user experience
    console.error('Analytics tracking error:', error);
  }
};

// Specific tracking functions
export const trackPageView = (userId) => {
  return trackEvent('page_view', { userId });
};

export const trackLinkClick = (userId, linkId) => {
  return trackEvent('link_click', { userId, linkId });
};

export const trackProfileDownload = (userId) => {
  return trackEvent('profile_download', { userId });
};

export const trackQRView = (userId) => {
  return trackEvent('qr_view', { userId });
};
